export const CASH_SESSION_STATUSES = ["OPEN", "CLOSED", "CANCELLED"] as const;
export type CashSessionStatus = typeof CASH_SESSION_STATUSES[number];

export const CASH_MOVEMENT_TYPES = [
  "OPENING",
  "INCOME",
  "EXPENSE",
  "ADJUSTMENT",
  "CLOSING",
] as const;
export type CashMovementType = typeof CASH_MOVEMENT_TYPES[number];

export const CASH_MANUAL_MOVEMENT_TYPES = ["INCOME", "EXPENSE", "ADJUSTMENT"] as const;
export type CashManualMovementType = typeof CASH_MANUAL_MOVEMENT_TYPES[number];

export const PAYMENT_METHODS = [
  "cash",
  "debit_card",
  "credit_card",
  "transfers",
  "other",
] as const;
export type PaymentMethod = typeof PAYMENT_METHODS[number];

export const CASH_SORT_ORDERS = ["ASC", "DESC"] as const;
export type CashSortOrder = typeof CASH_SORT_ORDERS[number];
